import React from 'react';
import PropTypes from 'prop-types';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import WarningIcon from '@mui/icons-material/Warning';
import { green } from '@mui/material/colors';
import IconButton from '@mui/material/IconButton';
import SnackbarContent from '@mui/material/SnackbarContent';
import Snackbar from '@mui/material/Snackbar';
import { useTheme } from '@mui/material/styles';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const Alert = (props) => {
  const theme = useTheme();

  const {
    className,
    message,
    open,
    onClose,
    variant,
    vertical,
    horizontal,
    ...other
  } = props;

  const Icon = variantIcon[variant];

  const backgroundByVariant = {
    success: green[600],
    error: theme.palette.error.dark,
    info: theme.palette.primary.main,
    warning: '#ee9321',
  };

  const iconStyle = {
    fontSize: 20,
  };

  const iconVariantStyle = {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  };

  const messageStyle = {
    display: 'flex',
    alignItems: 'center',
  };

  return (
    <Snackbar
      anchorOrigin={{
        vertical: vertical || 'bottom',
        horizontal: horizontal || 'center',
      }}
      open={open}
      autoHideDuration={12000}
      onClose={onClose}
    >
      <SnackbarContent
        sx={{
          backgroundColor: backgroundByVariant[variant],
        }}
        className={className}
        aria-describedby="client-snackbar"
        message={
          <span id="client-snackbar" style={messageStyle}>
            <Icon style={{ ...iconStyle, ...iconVariantStyle }} />
            {message}
          </span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="close"
            color="inherit"
            onClick={onClose}
          >
            <CloseIcon style={iconStyle} />
          </IconButton>,
        ]}
        {...other}
      />
    </Snackbar>
  );
};

Alert.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(['error', 'info', 'success', 'warning']).isRequired,
  vertical: PropTypes.oneOf(['top', 'bottom']),
  horizontal: PropTypes.oneOf(['left', 'center', 'right']),
  open: PropTypes.bool.isRequired,
};

export default Alert;
